import script from "./AllLive.vue?vue&type=script&setup=true&lang=js"
export * from "./AllLive.vue?vue&type=script&setup=true&lang=js"

import "./AllLive.vue?vue&type=style&index=0&id=fec4ac24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fec4ac24"]])

export default __exports__